<template>
  <v-app-bar
    class="position-relative header"
    scroll-threshold="100"
    color="transparent"
    shrink-on-scroll
    hide-on-scroll
    height="auto"
    tile
    flat
    app
  >
    <v-container class="py-3">
      <div class="align-center grid-list">
        <div class="d-flex justify-end">
          <v-btn
            class="
              primary--text
              text-body-1 text-none
              font-weight-medium
              mx-lg-2
              nav-link
            "
            active-class="text--lighten-2"
            to="/"
            tile
            depressed
            text
          >
            Página Inicial
          </v-btn>
          <v-btn
            class="
              primary--text
              text-body-1 text-none
              font-weight-medium
              mx-lg-2
              nav-link
            "
            active-class="text--lighten-2"
            to="/passeios"
            tile
            depressed
            text
          >
            Passeios
          </v-btn>
          <v-btn
            class="
              primary--text
              text-body-1 text-none
              font-weight-medium
              mx-lg-2
              nav-link
            "
            active-class="text--lighten-2"
            to="/pousadas"
            tile
            depressed
            text
          >
            Pousadas
          </v-btn>
        </div>

        <div class="d-flex justify-center">
          <router-link to="/">
            <v-img
              v-if="informations.img"
              class="d-block header-brand"
              :src="files + informations.img + '?resize=1&w=280'"
              :alt="informations.name"
              contain
            />
          </router-link>
        </div>

        <div class="d-flex justify-start">
          <v-btn
            class="
              primary--text
              text-body-1 text-none
              font-weight-medium
              mx-lg-2
              nav-link
            "
            active-class="text--lighten-2"
            to="/pacotes"
            tile
            depressed
            text
          >
            Pacotes
          </v-btn>
          <v-btn
            class="
              primary--text
              text-body-1 text-none
              font-weight-medium
              mx-lg-2
              nav-link
            "
            active-class="text--lighten-2"
            to="/day-use"
            tile
            depressed
            text
          >
            Day Use
          </v-btn>
          <v-btn
            class="
              primary--text
              text-body-1 text-none
              font-weight-medium
              mx-lg-2
              nav-link
            "
            active-class="text--lighten-2"
            to="/contato"
            tile
            depressed
            text
          >
            Orçamento/Contato
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    informationsContacts() {
      return this.$rest("informations-contacts").item;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  transition: all 0.1s linear;

  &:before {
    background: rgb(255, 255, 255);
    background: -moz-linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 35%,
      rgba(255, 255, 255, 0) 100%
    );
    background: -webkit-linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 35%,
      rgba(255, 255, 255, 0) 100%
    );
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 35%,
      rgba(255, 255, 255, 0) 100%
    );
    bottom: -50%;
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1);
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: background 0.1s linear;
  }

  .header-brand {
    transition: all 0.1s linear;
    max-width: 280px;
    width: 15vw;
  }

  &.v-app-bar--is-scrolled {
    &:before {
      background: rgb(255, 255, 255);
      background: -moz-linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 35%,
        rgba(255, 255, 255, 1) 100%
      );
      background: -webkit-linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 35%,
        rgba(255, 255, 255, 1) 100%
      );
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 35%,
        rgba(255, 255, 255, 1) 100%
      );
      bottom: 0;
      filter: none;
    }

    .header-brand::v-deep {
      width: 135px;

      .v-image__image {
        background-image: url(../../../assets/img/portalnobres.png) !important;
      }
    }
  }

  .grid-list {
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr 15vw 1fr;

    .nav-link {
      position: relative;

      &:before {
        content: "";
        opacity: 0 !important;
      }

      &:not(:last-child):after {
        background-color: #fc6fee;
        border-radius: 50%;
        content: "";
        height: 2px;
        margin-right: -9px;
        margin-top: -1px;
        position: absolute;
        top: 50%;
        right: 0;
        width: 2px;

        @media screen and (max-width: 1264px) {
          margin-right: -1px;
        }
      }
    }
  }
}
</style>
